import { Component } from '@angular/core';

@Component({
  selector: 'rid-keyboard-row',
  templateUrl: './rid-keyboard-row.html',
  styleUrl: './rid-keyboard-row.css',
})
export class RidKeyboardRow {}
